import { render, staticRenderFns } from "./Verschiebung.vue?vue&type=template&id=bfa0b03a"
import script from "./Verschiebung.vue?vue&type=script&lang=js"
export * from "./Verschiebung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports